module.exports = __webpack_public_path__ + "static/media/development-campos.2c443b7b.png";